// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-autocomplete-items .mat-mdc-form-field {
  width: 100%;
}

.fi-autocomplete-items-panel.mat-mdc-autocomplete-panel {
  margin-top: 5px;
  border-radius: 10px !important;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.12), 0px 5px 6px 0px rgba(0, 0, 0, 0.2), 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.fi-autocomplete-items-panel.mat-mdc-autocomplete-panel .mat-mdc-option {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-autocomplete-items/fi-autocomplete-items.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAIA;EACI,eAAA;EACA,8BAAA;EACA,yHACI;AAFR;AAKI;EACI,eAAA;AAHR","sourcesContent":[".fi-autocomplete-items {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.fi-autocomplete-items-panel.mat-mdc-autocomplete-panel {\r\n    margin-top: 5px;\r\n    border-radius: 10px !important;\r\n    box-shadow:\r\n        0px 3px 16px 0px rgba(0, 0, 0, 0.12),\r\n        0px 5px 6px 0px rgba(0, 0, 0, 0.2),\r\n        0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    .mat-mdc-option {\r\n        font-size: 14px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
